var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showNavbar)?_c('NavBar'):_vm._e(),_c('v-main',[_c('div',{attrs:{"id":_vm.$route.path === '/MainMenu' ? 'grad' : null}},[_c('router-view')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }